import React from "react";
import BondDocumentUploadBase from "../../shared/components/BondDocumentUploadBase";
import { PROBATE_DOCUMENT_UPLOAD_SECTIONS } from "../../shared/documentUploadConfig";

const DocumentUpload = (props) => (
  <BondDocumentUploadBase
    {...props}
    sections={PROBATE_DOCUMENT_UPLOAD_SECTIONS}
  />
);

export default DocumentUpload;
